import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { api } from '.';
import { handleRequestError } from '../utils/request';
/**
 * Query commodity list
 * @returns
 */

export var apiQueryGreateAmericanCommoditiyList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var res, list;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.get("/great_american/commodities");

          case 3:
            res = _context.sent;

            if (Array.isArray(res === null || res === void 0 ? void 0 : res.data)) {
              list = [];
              res.data.forEach(function (item) {
                Object.keys(item).forEach(function (aItem) {
                  list.push({
                    value: aItem,
                    label: item[aItem]
                  });
                });
              });
              res.data = list;
            }

            return _context.abrupt("return", [res.data]);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", handleRequestError(_context.t0, payload));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function apiQueryGreateAmericanCommoditiyList(_x) {
    return _ref.apply(this, arguments);
  };
}();